/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxSizeMB: NonNullable<unknown> }} Errors_Filesizetoolarge_Plural3Inputs */

const en_errors_filesizetoolarge_plural3 = /** @type {(inputs: Errors_Filesizetoolarge_Plural3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Some files are too large. Maximum file size is ${i?.maxSizeMB}MB`)
};

/**
* | output |
* | --- |
* | "Some files are too large. Maximum file size is {maxSizeMB}MB" |
*
* @param {Errors_Filesizetoolarge_Plural3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_filesizetoolarge_plural3 = /** @type {((inputs: Errors_Filesizetoolarge_Plural3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Filesizetoolarge_Plural3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_filesizetoolarge_plural3(inputs)
});
export { errors_filesizetoolarge_plural3 as "errors_fileSizeTooLarge_plural" }